import React from 'react';
import Button from './UC/Button';
import styles from './ErrorState.module.css';

export interface ErrorStateProps {
  title?: string;
  message: string;
  onRetry?: () => void;
  retryLabel?: string;
  showIcon?: boolean;
}

const ErrorState: React.FC<ErrorStateProps> = ({
  title = 'Error',
  message,
  onRetry,
  retryLabel = 'Reintentar',
  showIcon = true,
}) => {
  return (
    <div className={styles.errorState}>
      {showIcon && (
        <div className={styles.icon}>
          <i className="uc-icon icon-size--lg">error_outline</i>
        </div>
      )}
      <div className={styles.content}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.message}>{message}</p>
        {onRetry && (
          <div className={styles.actions}>
            <Button onClick={onRetry} variant="primary">
              {retryLabel}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ErrorState;
